function scrollToHash(FilterApi) {
    __ = null;

    this.render = function () {
        __ = this;

        if (window.location.hash) {
            __.scrollToHashTarget(window.location.hash);
        }
        $("[data-mm-scroll-to-hash]").on("click", function (e) {
            e.preventDefault();
            let hash = $(this).attr("data-mm-scroll-to-hash");
            window.location.hash = hash;
            __.scrollToHashTarget(window.location.hash);
        });
    };

    this.scrollToHashTarget = function (hash) {
        toggle_targer = hash.substring(1);

        $target = $("#" + toggle_targer);

        if ($target) {
            var extra_offset = $target.attr("data-mm-extra-offset")
                ? parseInt($target.attr("data-mm-extra-offset"))
                : 0;

            $("html, body").scrollTop($target.offset().top - extra_offset);
        }
    };
}

module.exports = scrollToHash;
